/**
 * App-bundle entry point for the shared logger (iframe app, widget, test env).
 *
 * The implementation — level precedence, the `__aqLog` live setter — lives in
 * `src/core/logger.ts` so the lib, the SDK and this bundle resolve levels
 * identically. See that file for the precedence chain.
 */

export { getLogger, getLogLevel, isLogLevel } from './core/logger';
export type { LogLevel, AqLogControl } from './core/logger';
